import { createContext, useContext, useState, useCallback } from 'react'

const NotificationContext = createContext(null)

export const useNotification = () => {
  const context = useContext(NotificationContext)
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider')
  }
  return context
}

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null)

  const showNotification = useCallback((message, type = 'success') => {
    setNotification({ message, type })
    
    // Auto-dismiss after 5 seconds
    setTimeout(() => {
      setNotification(null)
    }, 5000)
  }, [])

  const hideNotification = useCallback(() => {
    setNotification(null)
  }, [])

  const showSuccess = useCallback((message) => {
    showNotification(message, 'success')
  }, [showNotification])

  const showError = useCallback((message) => {
    showNotification(message, 'error')
  }, [showNotification])

  const value = {
    notification,
    showNotification,
    hideNotification,
    showSuccess,
    showError,
  }

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  )
}

export default NotificationContext
